// Utility to take a Class and apply an arbitrary number of mixins to it.

// Note: mixins are applying in order of definition, meaning the first mixin supplied
// will be the first to wrap the Clazz
export default function (Clazz) {
  return function () {
    return [].slice.call(arguments).reduce((memo, mixin) => {
      return mixin(memo);
    }, Clazz);
  };
}
